import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';
import { mergeWith } from 'lodash';

const localOptions = {
    identifiers: {
        opportunity: {
            title: window.i18n.__('Critère de comparaison pour les opportunités'),
            multiple: false,
            choices: [
                {
                    value: 'reference',
                    label: window.i18n.__('Identifiant d’opportunité'),
                    description: window.sellsyapp.config.globalProperties.$t.__(
                        'settings.import.options.importOpportunityOptionsDictionary.identifiersOpportunityReferenceDescription',
                    ),
                },
                {
                    value: 'id',
                    label: window.i18n.__('ID d’opportunité'),
                    description: window.sellsyapp.config.globalProperties.$t.__(
                        'settings.import.options.importOpportunityOptionsDictionary.identifiersOpportunityIdDescription',
                    ),
                },
            ],
        },
        company: {
            title: window.i18n.__('Critère de comparaison pour les sociétés'),
            multiple: false,
            choices: [
                {
                    value: 'company_name',
                    label: window.i18n.__('Nom Client / Prospect'),
                    description: window.sellsyapp.config.globalProperties.$t.__(
                        'settings.import.options.importOpportunityOptionsDictionary.identifiersCompanyNameDescription',
                    ),
                },
                {
                    value: 'company_id',
                    label: window.i18n.__('ID Client / Prospect'),
                    description: window.sellsyapp.config.globalProperties.$t.__(
                        'settings.import.options.importOpportunityOptionsDictionary.identifiersCompanyIdDescription',
                    ),
                },
            ],
        },
    },
    description: window.i18n.__(
        'Cette étape vous permet de définir les paramètres que nous devons appliquer lors de l’analyse de votre ficher puis de l’import de vos données dans Sellsy.',
    ),
    parameters: {
        create_and_update: {
            title: window.i18n.__('Création / Mise à jour'),
            options: {
                create_and_update_records: {
                    values: [
                        {
                            value: 'create_and_update',
                            label: window.i18n.__(
                                'Ajouter et mettre à jour les données dans Sellsy',
                            ),
                        },
                    ],
                },
            },
        },
    },
};

function mergeCustomizer(objValue, srcValue, key, object, source) {
    if (key === 'create_and_update' && source === localOptions.parameters) {
        return srcValue;
    }
    return undefined;
}

const mergedOptions = mergeWith(globalOptions, localOptions, mergeCustomizer);

const optionsSelected = {
    create_and_update_records: 'create_and_update',
    update_empty_fields: 'N',
    overwrite_tags: 'N',
    dismiss_required_custom_fields: 'Y',
    insert_new_custom_fields_enum_values: 'N',
    use_default_values_for_empty_custom_fields: 'Y',
};

function filterValuesByDefault(options, defaults) {
    Object.keys(options).forEach((key) => {
        const defaultValue = defaults[key];
        if (options[key].values) {
            options[key].values = options[key].values.filter((item) => item.value === defaultValue);
        }
    });
}

filterValuesByDefault(mergedOptions.parameters.create_and_update, optionsSelected);
filterValuesByDefault(mergedOptions.customFields, optionsSelected);

export const options = mergedOptions;

export const defaultOptions = {
    identifiers: {
        opportunity: ['reference'],
        company: ['company_name'],
    },
    ...optionsSelected,
};
